import { alpha, createMuiTheme } from "@material-ui/core";
import React from "react";

const red = "#B92B28";
const greenBlue = "#1565C0";
const switchColor = "#FC2D2D";

export const colors = {
    red: {
        original: red,
        alpha: {
            64: alpha(red, 0.64),
        },
    },
    brand: {
        blue: { main: greenBlue, light: "#18586C" },
    },
    components: {
        switch: {
            red: switchColor,
        },
    },
    thirdParty: {
        whatsApp: "#62c451",
    },
};

const theme = createMuiTheme({
    palette: {
        primary: { main: greenBlue },
    },
    typography: {
        fontFamily: ['"Helvetica Neue"', "sans-serif"].join(","),
        fontWeightBold: 600,
        h6: {
            fontSize: "1.125rem",
        },
        subtitle1: {
            fontSize: "0.75rem",
            fontWeight: 600,
        },
        subtitle2: {
            fontSize: "0.6875rem",
            fontWeight: 500,
        },
        button: {
            textTransform: "none",
        },
        button2: {
            fontSize: "0.6875rem",
            textTransform: "none",
            fontWeight: 500,
        },
        caption2: {
            fontSize: "0.6875rem",
        },
    },

    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottom: `1px solid ${greenBlue}`,
                    },
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottom: `1px solid ${greenBlue} !important`,
                    },
                    "&:after": {
                        borderBottom: `2px solid ${greenBlue}`,
                    },
                },
            },
        },
    },
});

export default theme;

declare module "@material-ui/core/styles" {
    interface TypographyVariants {
        button2: React.CSSProperties;
        caption2: React.CSSProperties;
    }

    // allow configuration using `createMuiTheme`
    interface TypographyVariantsOptions {
        button2?: React.CSSProperties;
        caption2?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module "@material-ui/core/Typography" {
    interface TypographyPropsVariantOverrides {
        button2: true;
        caption2: true;
    }
}
